// 需要全局的mixin..谨慎使用
import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters(['currencyCfg', 'currencyDisplaySymbol', 'currencyDisplayName']),
  },
};
